(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Ensure out-of-stock items stay at the bottom of the grid across dynamic updates/infinite scroll
  let isSortingOos = false;
  function moveOutOfStockToBottom() {
    if (isSortingOos) return;
    const gridContainers = document.querySelectorAll('.product-grid, ul[ref="grid"], .product-grid-container ul');
    gridContainers.forEach((grid) => {
      const items = Array.from(grid.children).filter((el) => el.matches('li.product-grid__item'));
      if (items.length <= 1) return;

      let hasOosFollowedByInStock = false;
      let seenOos = false;

      for (const item of items) {
        const isOos =
          item.classList.contains('product-grid__item--out-of-stock') ||
          item.getAttribute('data-available') === 'false';
        if (isOos) {
          seenOos = true;
        } else if (seenOos) {
          hasOosFollowedByInStock = true;
          break;
        }
      }

      if (hasOosFollowedByInStock) {
        isSortingOos = true;
        items.forEach((item) => {
          const isOos =
            item.classList.contains('product-grid__item--out-of-stock') ||
            item.getAttribute('data-available') === 'false';
          if (isOos) {
            grid.appendChild(item);
          }
        });
        setTimeout(() => {
          isSortingOos = false;
        }, 60);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveOutOfStockToBottom);
  } else {
    moveOutOfStockToBottom();
  }

  const resultsComponent = document.querySelector('results-list') || document.querySelector('collection-component');
  if (resultsComponent) {
    const oosObserver = new MutationObserver(() => {
      moveOutOfStockToBottom();
    });
    oosObserver.observe(resultsComponent, { childList: true, subtree: true });
  }

  } catch(e) { console.error(e); }
})();
})();
